<div class="flex flex-col gap-4 animate-pulse">
    <div class="flex flex-col">
        @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
            <div class="flex flex-col items-center w-0.5 ml-8">
                <div class="w-8 h-8 rounded-full bg-light-bgHoverColor dark:bg-dark-bgHoverColor"></div>

                @if ($index !== 5) {
                    <div class="w-0.5 h-24 bg-light-bgHoverColor dark:bg-dark-bgHoverColor"></div>
                }
            </div>
        }
    </div>
</div>
